module.exports = __webpack_public_path__ + "img/welcome-big-screen-circles.0c084799.png";